import React, { Component } from 'react';
import { Form } from 'antd';
import ReportDescription from './ReportDescription'
import PrintersSelectTable from './PrintersSelectTable'
import UsersSelectTable from './UsersSelectTable'
import UserGroupsSelectTable from './UserGroupsSelectTable'
import {getReportParam} from '../utils/EmailReportsHelper'
import {REPORT_URL} from '../utils/constants'

const layout = {
    labelCol: {
        offset: 0,
        span: 3,
    },
/*    
    wrapperCol: {       
        offset: 0,
        span: 6,
    },
*/    
  };
  
const report_type_name = "Report.PrintedJobs";
const printer_id_name = "printer_id";
const user_id_name = "user_id";
const group_id_name = "group_id";
const report_url = "/jobs";

class PrintedJobsStep2 extends Component {

    constructor(props) {
        super(props);

        this.printer_id = this.getPrinterId();
        if (this.printer_id !== undefined)
        {
            this.savePrinterId(this.printer_id);
        }

        this.user_id = this.getUserId();
        if (this.user_id !== undefined)
        {
            this.saveUserId(this.user_id);
        }

        this.group_id = this.getGroupId();
        if (this.group_id !== undefined)
        {
            this.saveGroupId(this.group_id);
        }


        this.props.callbacks.setStoreValue(report_type_name, REPORT_URL, report_url);
    }

    savePrinterId(printer_id)
    {
        this.props.callbacks.setStoreValue(report_type_name, printer_id_name, printer_id);
    }

    getPrinterId()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, printer_id_name, this.props.report.url);
    }

    saveUserId(user_id)
    {
        this.props.callbacks.setStoreValue(report_type_name, user_id_name, user_id);
    }

    getUserId()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, user_id_name, this.props.report.url);
    }

    saveGroupId(group_id)
    {
        this.props.callbacks.setStoreValue(report_type_name, group_id_name, group_id);
    }

    getGroupId()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, group_id_name, this.props.report.url);
    }

    onSelectChangePrinter(selectedRowKeys) {
        this.printer_id = selectedRowKeys[0];
        this.savePrinterId(this.printer_id);
    }

    onSelectChangeUser(selectedRowKeys) {
        this.user_id = selectedRowKeys[0];
        this.saveUserId(this.user_id);
    }

    onSelectChangeUserGroup(selectedRowKeys) {
        this.group_id = selectedRowKeys[0];
        this.saveGroupId(this.group_id);
    }

    render() {
    
        return (
            <div style={{align:"left", textAlign: "left"}}>
                <br/>
                <Form {... layout}
                    name="basic"
                >
                    <Form.Item>
                    <PrintersSelectTable 
                        printer_id = {this.printer_id}
                        onSelectChange = {(selectedRowKeys) => this.onSelectChangePrinter(selectedRowKeys)}/>
                    </Form.Item>
                    <Form.Item>
                    <UsersSelectTable 
                        user_id = {this.user_id}
                        onSelectChange = {(selectedRowKeys) => this.onSelectChangeUser(selectedRowKeys)}/>
                    </Form.Item>
                    <Form.Item>
                    <UserGroupsSelectTable 
                        group_id = {this.group_id}
                        onSelectChange = {(selectedRowKeys) => this.onSelectChangeUserGroup(selectedRowKeys)}/>
                    </Form.Item>
                </Form>
                <ReportDescription description="Report.PrintedJobs.Description"/>             
            </div>
        );
      }
}

export default PrintedJobsStep2;